import type { StateCreator } from 'zustand'

import { type LifeticketState, INITIAL_STATE } from './types'

const createLifeticketSlice: StateCreator<LifeticketState, [], [], LifeticketState> = (set) => ({
  lifeticket: INITIAL_STATE,
  setLifeticketObject: (lifeticket) => set(() => ({ lifeticket })),
  setLifeticktCancellation: (lifeticketCancellation) =>
    set((state) => ({
      lifeticket: {
        ...state.lifeticket,
        cancellation: {
          ...state.lifeticket.cancellation,
          cancellation: lifeticketCancellation,
        },
      },
    })),
  setLifeticketCancellationReceipt: (receipt) =>
    set((state) => ({
      lifeticket: {
        ...state.lifeticket,
        cancellation: { ...state.lifeticket.cancellation, receipt },
      },
    })),
  resetLifeticket: () => set(() => ({ lifeticket: INITIAL_STATE })),
})

export default createLifeticketSlice
